import * as i0 from "@angular/core";
var ValidatedTokenService = /** @class */ (function () {
    function ValidatedTokenService() {
    }
    Object.defineProperty(ValidatedTokenService.prototype, "jwt", {
        get: function () {
            var token = localStorage.getItem('token');
            return token;
        },
        enumerable: true,
        configurable: true
    });
    ValidatedTokenService.prototype.DOMParser = function (strToSanitize) {
        var body = new DOMParser().parseFromString(strToSanitize, 'text/html').body;
        return body.textContent || '';
    };
    ValidatedTokenService.ngInjectableDef = i0.defineInjectable({ factory: function ValidatedTokenService_Factory() { return new ValidatedTokenService(); }, token: ValidatedTokenService, providedIn: "root" });
    return ValidatedTokenService;
}());
export { ValidatedTokenService };
